var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "search-fellow-box" },
    [
      _c("div", { staticClass: "search-input-box flexBox" }, [
        _c("div", { staticClass: "search-box" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.keywords,
                expression: "keywords"
              }
            ],
            ref: "searchinput",
            staticClass: "search-input",
            attrs: {
              type: "search",
              maxlength: "50",
              placeholder: "输入车主全名/昵称/手机",
              spellcheck: "false"
            },
            domProps: { value: _vm.keywords },
            on: {
              keyup: function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                return _vm.getSearch($event)
              },
              focus: _vm.searchFocus,
              blur: _vm.SearchBlur,
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.keywords = $event.target.value
              }
            }
          })
        ]),
        _vm._v(" "),
        _c(
          "i",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.keywords,
                expression: "keywords"
              }
            ],
            staticClass: "icon icon-searchClose search-close",
            on: { click: _vm.ClearSearch }
          },
          [
            _c("span", { staticClass: "path1" }),
            _c("span", { staticClass: "path2" })
          ]
        ),
        _vm._v(" "),
        _c(
          "span",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isSearch,
                expression: "isSearch"
              }
            ],
            staticClass: "search-btn",
            class: { "search-btn-disabled": !_vm.keywords },
            on: { click: _vm.getSearch }
          },
          [_vm._v("搜索")]
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.actionSearch,
              expression: "!actionSearch"
            }
          ],
          staticClass: "search-fellow-tip padding-sets"
        },
        [
          _c("p", { staticClass: "tip-head" }, [_vm._v("提示")]),
          _vm._v(" "),
          _c("span", { staticClass: "tip-content" }, [
            _vm._v("可以通过输入车主的全名来精确查找该车主Fellow")
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.actionSearch,
              expression: "!actionSearch"
            }
          ],
          staticClass: "search_fellow_img padding-sets"
        },
        [
          _c("img", {
            attrs: { src: "/static/images/fellowImg.png" },
            on: { click: _vm.goOrderData }
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "search_fellow_img_title",
              on: { click: _vm.goOrderData }
            },
            [
              _vm._m(0),
              _vm._v(" "),
              _c("div", { staticClass: "order_next" }, [
                _vm._v("(正在规划敬请期待)")
              ])
            ]
          )
        ]
      ),
      _vm._v(" "),
      _vm.fellowResult
        ? _vm._l(_vm.fellowResult, function(result) {
            return _c(
              "section",
              { staticClass: "search-fellow-list padding-sets" },
              [
                _c("div", { staticClass: "consumer-container flexBox" }, [
                  _c("img", {
                    staticClass: "consumer-avator",
                    attrs: { src: result.custom.avator },
                    on: { error: _vm.$imgErr }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "consumer-info flexItem" }, [
                    _c("p", { staticClass: "base-info" }, [
                      _c("span", {
                        staticClass: "name",
                        domProps: { textContent: _vm._s(result.custom.name) }
                      }),
                      _vm._v(" "),
                      result.custom.nickName
                        ? _c("span", {
                            staticClass: "nickname",
                            domProps: {
                              textContent: _vm._s(
                                "(" + result.custom.nickName + ")"
                              )
                            }
                          })
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "car-info" }, [
                      _c("span", {
                        staticClass: "cartype",
                        class: { "cartype-border": result.custom.carType },
                        domProps: { textContent: _vm._s(result.custom.carType) }
                      })
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "other-info" }, [
                      _c("span", {
                        staticClass: "telephone",
                        domProps: {
                          textContent: _vm._s(result.custom.telephone)
                        }
                      }),
                      _vm._v(" "),
                      _c("span", {
                        staticClass: "workplace",
                        domProps: {
                          textContent: _vm._s(result.custom.workPlace)
                        }
                      })
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "fellow-container" }, [
                  _c("h3", [_vm._v("Ta的专属Fellow")]),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass: "fellow-tel-wrap flexBox",
                      on: {
                        click: function($event) {
                          return _vm.callPhone(result.fellow.telephone)
                        }
                      }
                    },
                    [
                      _c("img", {
                        staticClass: "fellow-avator",
                        attrs: { src: result.fellow.avator },
                        on: { error: _vm.$imgErr }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "fellow-info flexItem" }, [
                        _c("p", {
                          staticClass: "account",
                          domProps: { textContent: _vm._s(result.fellow.name) }
                        }),
                        _vm._v(" "),
                        _c("p", {
                          staticClass: "location",
                          domProps: {
                            textContent: _vm._s(result.fellow.workPlace)
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _vm._m(1, true)
                    ]
                  )
                ])
              ]
            )
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.unSatisfyTip,
              expression: "unSatisfyTip"
            }
          ],
          staticClass: "search-noresult-tip"
        },
        [_vm._m(2)]
      ),
      _vm._v(" "),
      _vm.toastShow
        ? _c("nio-toast", {
            attrs: { showing: _vm.toastShow, text: _vm.tipText }
          })
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "img_title" }, [
      _c("span", [_vm._v("车主订单数据一站式查询")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "fellow-tel" }, [
      _c("img", {
        staticClass: "tel",
        attrs: { src: "/static/images/tel.png" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "noresult flexBox" }, [
      _c("i", { staticClass: "icon icon-noInfo" }),
      _vm._v(" "),
      _c("p", { staticClass: "fellow-noresult-text" }, [
        _vm._v("未找到搜索结果")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "fellow-noresult-text" }, [
        _vm._v("必须输入完整信息才能查询出结果")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-38eecf68", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-38eecf68","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/views/search/searchFellow.vue
// module id = null
// module chunks = 